import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import it from './locales/it.json'
import en from './locales/en.json'
import de from './locales/de.json'
import type { Locale } from '../lib/api/types'

export const SUPPORTED_LOCALES: Locale[] = ['it', 'en', 'de']

function detectInitialLocale(): Locale {
  // 1) URL path prefix /it /en /de  2) localStorage  3) browser  4) default it
  const seg = window.location.pathname.split('/').filter(Boolean)[0] as Locale | undefined
  if (seg && SUPPORTED_LOCALES.includes(seg)) return seg
  const stored = window.localStorage.getItem('gsm_locale') as Locale | null
  if (stored && SUPPORTED_LOCALES.includes(stored)) return stored
  const nav = navigator.language.slice(0, 2) as Locale
  return SUPPORTED_LOCALES.includes(nav) ? nav : 'it'
}

i18n.use(initReactI18next).init({
  resources: {
    it: { translation: it },
    en: { translation: en },
    de: { translation: de },
  },
  lng: detectInitialLocale(),
  fallbackLng: 'it',
  interpolation: { escapeValue: false },
})

export default i18n
